import { atom } from 'recoil';

export const mobileToolboxVisibleAtom = atom({
  key: 'mobileToolboxVisibleAtom',
  default: false,
});
